import { put, takeEvery, call } from "redux-saga/effects";

import * as apis from "../../network/apis/verificationRequests";
import {
  getPendingRequestsListResponse,
  getRequestsHistoryListResponse,
} from "./slice";
import { showSnackMsg } from "../../utils/Helpers";
import { setCanShowEmptyState, setSkeletonObject } from "../Loader/slice";

export function* getPendingRequestsListSaga({ payload }) {
  try {
    yield put(getPendingRequestsListResponse({}));
    yield put(setSkeletonObject({ field: "table", value: true }));
    const response = yield call(apis.getPendingVerificationRequests, payload);
    const meta = {
      currentPage: +response.headers["current-page"],
      count: +response.headers["total-count"],
      pages: +response.headers["total-pages"],
      totalPendingRequests: +response.headers["total-count"],
    };
    const requests = response.data?.verification_requests;
    yield put(getPendingRequestsListResponse({ requests, meta }));
    yield put(setSkeletonObject({ field: "table", value: false }));
    if (requests.length === 0) {
      yield put(setCanShowEmptyState(true));
    } else {
      yield put(setCanShowEmptyState(false));
    }
  } catch (err) {
    yield put(setSkeletonObject({ field: "table", value: false }));
    yield put(setCanShowEmptyState(true));
    yield err.response?.status !== 401 &&
      showSnackMsg(err.response?.data?.message);
  }
}

export function* getRequestsHistoryListSaga({ payload }) {
  try {
    yield put(getRequestsHistoryListResponse({}));
    yield put(setSkeletonObject({ field: "table", value: true }));
    const response = yield call(apis.getVerificationRequestsHistory, payload);
    const meta = {
      currentPage: +response.headers["current-page"],
      count: +response.headers["total-count"],
      pages: +response.headers["total-pages"],
      totalPendingRequests: +response.headers["total-count"],
    };
    const requests = response.data?.verification_requests;
    yield put(getRequestsHistoryListResponse({ requests, meta }));
    yield put(setSkeletonObject({ field: "table", value: false }));
    if (requests.length === 0) {
      yield put(setCanShowEmptyState(true));
    } else {
      yield put(setCanShowEmptyState(false));
    }
  } catch (err) {
    yield put(setSkeletonObject({ field: "table", value: false }));
    yield put(setCanShowEmptyState(true));
    yield err.response?.status !== 401 &&
      showSnackMsg(err.response?.data?.message);
  }
}

export default function* VerificationRequestsSagas() {
  yield takeEvery(
    "verificationRequests/getPendingRequestsListRequest",
    getPendingRequestsListSaga
  );
  yield takeEvery(
    "verificationRequests/getRequestsHistoryListRequest",
    getRequestsHistoryListSaga
  );
}
